import {
  ApplicationConfig,
  importProvidersFrom,
  provideAppInitializer,
} from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';

import { AuthConfigModule } from './core/modules/auth-config.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AuthService } from './services/auth/auth.service';
import { RbsService } from './services/rbs/rbs.service';

import { BrowserModule } from '@angular/platform-browser';
import { apolloProviderConfig } from './core/modules/apollo-angular/graphql.config';
import { APP_ROUTES } from './app.routes';
import { LCPAdminFeaturesService } from '@setup/prevailing-wage-setup/lcp-admin-features/lcp-admin-features.service';
import { MasterWageDataService } from '@setup/prevailing-wage-setup/master-wage-data/master-wage-data.service';
import { DATE_FORMAT_PROVIDERS } from '@shared/constants/simple-data-format';
import { ManageMinimumWageService } from '@setup/prevailing-wage-setup/manage-minimum-wage/service/manage-minimum-wage.service';
import { ProvideApplicationInsights } from '@services/monitor/provide-application-insights';
import { initializeApplicationInsights } from '@services/monitor/initializeApplicationInsights';

export const APP_CONFIG: ApplicationConfig = {
  providers: [
    ...DATE_FORMAT_PROVIDERS,
    ...ProvideApplicationInsights(),
    provideAppInitializer(initializeApplicationInsights()),
    apolloProviderConfig,
    AuthService,
    importProvidersFrom(
      AuthConfigModule,
      BrowserAnimationsModule,
      BrowserModule,
      LCPAdminFeaturesService,
      ManageMinimumWageService,
      MasterWageDataService
    ),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter([...APP_ROUTES], withComponentInputBinding()),
    RbsService,
    provideHttpClient(),
  ],
};
